import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Auth0Context, useAuth0 } from "@auth0/auth0-react";
import { auth, signInWithGoogle } from "./firebase";
import { useState } from "react";
import { useUserAuth } from "./UserAuthContext";
import { Button } from "react-bootstrap";
const Navbar = () => {

  const { logOut, user } = useUserAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light ">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <h2 style={{ color: "green" }}>CocoNeoBank</h2>
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item ms-1">
                <NavLink className="nav-link " aria-current="page" to="/HomeLogged">
                  Home
                </NavLink>
              </li>
              {
                user ? <li className="nav-item ms-1">
                <NavLink className="nav-link" aria-current="page" to="/52highlowlogin">
                  52w high/ low
                </NavLink>
              </li> :
                <li className="nav-item ms-1">
                <NavLink className="nav-link" aria-current="page" to="/52highlow">
                  52w high/ low
                </NavLink>
              </li>
              }
              
              <li className="nav-item ms-1">
                <NavLink className="nav-link" aria-current="page" href="#services">
                  Volume Data
                </NavLink>
              </li>
              <li className="nav-item ms-1">
                <NavLink className="nav-link" aria-current="page" href="#services">
                  Blog
                </NavLink>
              </li>
              <li className="nav-item ms-1">
              <span className="d-flex justify-content-center" aria-current="page" href="#team">
                {user && (
                  <p
                    className="nav-link mb-3 text-center ms-2"
                    style={{ color: "#43A047", marginTop: "15px" }}
                  >
                    Welcome! {user.displayName}
                  </p>
                )}
              </span>
            </li>
            </ul>
            <div className="d-flex">
              {
                user ?<Button variant="success ms-4" onClick={handleLogout}>
                Logout
              </Button> :
              <NavLink to="/login">

                <Button variant="success" >
                LogIn
              </Button>
              </NavLink>
              }
              
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
